import {initMainHeader} from '../js/src/header-init';
import '../scss/pages/support.scss';

initMainHeader();
